import { InjectionToken, Signal } from '@angular/core';
import { Observable } from 'rxjs';

/** The minimal site shape the shell's routing guards need — just enough to redirect by id. */
export interface ShellSiteRef {
  readonly id: string;
}

/**
 * Contract the app provides so `@privaci/core`'s shell guards (onboardingGuard,
 * firstSiteRedirectGuard) can check "does this user have any sites" without the library
 * depending on the app's own SitesService. Wire it in app.config.ts:
 * `{ provide: SITES_PROVIDER, useExisting: SitesService }` — SitesService already satisfies
 * this shape (a `sites` signal + a `loadSites()` observable).
 */
export interface ShellSitesProvider {
  readonly sites: Signal<readonly ShellSiteRef[]>;
  loadSites(): Observable<readonly ShellSiteRef[]>;
}

export const SITES_PROVIDER = new InjectionToken<ShellSitesProvider>('SITES_PROVIDER');
